module.exports = __webpack_public_path__ + "img/arrow-down.4a40c1f2.svg";